// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// 🔹 Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDjCRrVyNOgPvzPl3YPJmV9sx2AQTVGw_Q",
  authDomain: "origami-app-7226e.firebaseapp.com",
  projectId: "origami-app-7226e",
  storageBucket: "origami-app-7226e.appspot.com",
  messagingSenderId: "1068713284644",
  appId: "1:1068713284644:web:75da62e80ef97c63a874b1",
  measurementId: "G-817Y2KKXL0"
};

// 🔹 Initialize Firebase
const app = initializeApp(firebaseConfig);

// 🔹 Authentication
export const auth = getAuth(app);

// 🔹 Firestore
export const db = getFirestore(app);
